<template>
  <div v-if="user" class="content-bottom">
    <div class="bottom-icon" @click="goHome()">
      <HomeIcon />
    </div>
    <div class="bottom-icon" @click="search()">
      <SearchIcon />
    </div>
    <div class="bottom-icon" @click="goCart()">
      <BasketIcon />
    </div>
    <div class="bottom-icon" @click="goOffer()">
      <OfferIcon v-if="offerEnable" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import HomeIcon from "./../layout/src/button/HomeIcon";
import SearchIcon from "./../layout/src/button/SearchIcon.vue";
import OfferIcon from "./../offer/src/OfferIcon.vue";
import BasketIcon from "./../layout/src/button/BasketIcon.vue";
import UserDropDownButton from "./../layout/src/button/UserDropDownButton.vue";

export default {
  components: {
    HomeIcon,
    OfferIcon,
    BasketIcon,
    SearchIcon,
    UserDropDownButton
  },
  data() {
    return {
      offerEnable: ""
    };
  },
  methods: {
    goHome() {
      this.$router.replace({ name: "welcomePage" });
    },
    search() {
      this.$router.replace({ name: "searchPage" });
    },
    goCart() {
      this.$router.replace({ name: "cart" });
    },
    goOffer() {
      this.$router.replace({ name: "offer" });
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.authorizedUser
    })
  },

  beforeMount() {
    this.offerEnable = this.$config.get("offer.enable");
  }
};
</script>




// WEBPACK FOOTER //
// src/components/template/BottomMobilePanel.vue